import React from 'react';
import css from 'src/styles/App.scss';
import cx from 'classnames';

const TextButton = props => {
    const defaultClassName = props.disabled ? css.textButtonDisabled : css.textButton;

    return (
        <div
            tabIndex={0}
            role="button"
            className={props.className ? cx(defaultClassName, props.className) : defaultClassName}
            data-cwid={`btn_${props.automationName}`}
            onClick={props.disabled ? undefined : props.onClick}
            onKeyDown={
                props.disabled
                    ? undefined
                    : e => {
                          if (e.keyCode === 13 || e.keyCode === 32) props.onClick();
                      }
            }
            title={props.title}
            style={props.style}
            onMouseEnter={props.onMouseEnter}>
            {props.text}
        </div>
    );
};

export default TextButton;
